import React, { useEffect } from "react";
import "./scroll.css";

const ScrollToTopButton = () => {
  const calcScrollValue = () => {
    const scrollProgress = document.querySelector(".progress");
    if (!scrollProgress) return;
    const pos = document.documentElement.scrollTop;

    if (pos > 700) {
      scrollProgress.classList.add("active");
    } else {
      scrollProgress.classList.remove("active");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", calcScrollValue);
    window.addEventListener("load", calcScrollValue);
    return () => {
      window.removeEventListener("scroll", calcScrollValue);
      window.removeEventListener("load", calcScrollValue);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="progress"
      onClick={handleClick}
      style={{
        background: `linear-gradient(to top, var(--main-color), var(--grey-color))`,
      }}
    >
      <i className="uil uil-angle-double-up progress-value" />
    </div>
  );
};

export default ScrollToTopButton;
